import Vue from "vue";
import Buefy from "buefy";

import CheckoutApp from "./App.vue"
import OrderData from "./components/OrderData.vue"
import Payment from "./components/Payment.vue"
import CartDetail from "./components/CartDetail.vue"

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(CheckoutApp)
Vue.use(OrderData)
Vue.use(Payment)
Vue.use(CartDetail)

if(document.getElementById("checkoutApp")){
    new Vue({
        render:h=>h(CheckoutApp,{
            props:{
                userEmail:document.getElementById("checkoutApp")
                    .getAttribute("userEmail"),
                userProfileUrl:document.getElementById("checkoutApp")
                    .getAttribute("profile-url"),
                createUrl:document.getElementById("checkoutApp")
                    .getAttribute("createUrl"),
                cartDetailUrl:document.getElementById("checkoutApp")
                    .getAttribute("cartDetailUrl"),
                channelList:document.getElementById("checkoutApp")
                    .getAttribute("channelList"),
                mpChannel:document.getElementById("checkoutApp")
                    .getAttribute("mp-channel"),
                transferChannel:document.getElementById("checkoutApp")
                    .getAttribute("transfer-channel"),
                paypalChannel:document.getElementById("checkoutApp")
                    .getAttribute("paypal-channel"),
                cashChannel:document.getElementById("checkoutApp")
                    .getAttribute("cash-channel"),
                shipmentListUrl:document.getElementById("checkoutApp")
                    .getAttribute("shipment-list-url"),
                mpPubKey:document.getElementById("checkoutApp")
                    .getAttribute("mp-pub-key"),
                manualValidation:document.getElementById("checkoutApp")
                    .getAttribute("manual-order-validation"),
                couponFind:document.getElementById("checkoutApp")
                    .getAttribute("coupon-find"),
                ppMinOrder: document.getElementById("checkoutApp")
                    .getAttribute("pp-min-order"),
                mpMinOrder: document.getElementById("checkoutApp")
                    .getAttribute("mp-min-order"),
                usdReports: document.getElementById("checkoutApp")
                    .getAttribute("usd-reports"),
                hasCustomFields: document.getElementById("checkoutApp")
                    .getAttribute("has-custom-fields"),
                customFieldsName: document.getElementById("checkoutApp")
                    .getAttribute("custom-fields-name"),
                customFieldsUrl:document.getElementById("checkoutApp")
                    .getAttribute("custom-fields-list"),
                deliveryDateControl:document.getElementById("checkoutApp")
                    .getAttribute("delivery-date-control"),
                universalCheckout:document.getElementById("checkoutApp")
                    .getAttribute("universal-checkout"),
                bambooChannel:document.getElementById("checkoutApp")
                    .getAttribute("bamboo-channel"),
                bambooClientId:document.getElementById("checkoutApp")
                    .getAttribute("bamboo-client-id"),
                bambooKey:document.getElementById("checkoutApp")
                    .getAttribute("bamboo-key"),
                bambooMethodsUrl: document.getElementById("checkoutApp")
                    .getAttribute("bamboo-methods-url"),
                bambooUrl: document.getElementById("checkoutApp")
                    .getAttribute("bamboo-url")
            }
        })
    }).$mount("#checkoutApp")
}